const RELOAD_GUARD_MS = 10000
const RELOAD_KEY = 'chunkReloadAt'

function readGuard (storage) {
  try { return storage.getItem(RELOAD_KEY) } catch { return null }
}

function writeGuard (storage, value) {
  try { storage.setItem(RELOAD_KEY, value) } catch { /* storage bloqueado: se pierde el anti-bucle, no el fix */ }
}

function removeGuard (storage) {
  try { storage.removeItem(RELOAD_KEY) } catch { /* storage bloqueado: nada que limpiar */ }
}

export function isChunkLoadError (error) {
  if (!error) return false
  const name = error.name || ''
  const message = error.message || ''
  return name === 'ChunkLoadError'
    || /Loading chunk [\w-]+ failed/i.test(message)
    || /Loading CSS chunk [\w-]+ failed/i.test(message)
    // Vite / Rolldown: un import() dinamico cuyo hash ya no existe tras un deploy
    // no tira ChunkLoadError, tira estos mensajes y ademas el evento vite:preloadError.
    || /Failed to fetch dynamically imported module/i.test(message)
    || /error loading dynamically imported module/i.test(message)
    || /Unable to preload CSS/i.test(message)
}

export function handleChunkLoadError (error, to, deps = {}) {
  const {
    storage = window.sessionStorage,
    reload = (path) => window.location.assign(path),
    now = () => Date.now(),
    currentPath = () => window.location.pathname
  } = deps

  if (!isChunkLoadError(error)) return false

  const raw = readGuard(storage)
  const last = raw === null ? Number.NEGATIVE_INFINITY : Number(raw)
  if (now() - last < RELOAD_GUARD_MS) return false

  writeGuard(storage, String(now()))
  reload(to?.fullPath || currentPath())
  return true
}

export function clearChunkReloadGuard (deps = {}) {
  const { storage = window.sessionStorage } = deps
  removeGuard(storage)
}

// Router.onError solo cubre los import() de rutas. Los otros import() dinamicos
// (los ~160 defineAsyncComponent de tipos de item, PhotoEditor, etc.) no pasan por
// el router: cuando su chunk ya no existe tras un deploy, Vite emite vite:preloadError
// y, si nadie llama preventDefault, re-lanza el error. Enganchamos ese evento a la
// misma red con anti-bucle. Devuelve la funcion para desuscribir (util en tests).
export function registerChunkReloadListener (deps = {}) {
  const { target = window, ...rest } = deps
  const handler = (event) => {
    // event.payload es el Error. Vite: si nadie llama preventDefault, re-lanza el
    // error y el import() rechaza.
    if (!isChunkLoadError(event.payload)) return
    // Solo suprimimos el rethrow cuando de verdad recargamos. Si el anti-bucle
    // bloquea la recarga, dejamos que Vite re-lance: asi el rechazo llega al
    // errorComponent/onError de defineAsyncComponent (tipos de item) en vez de
    // resolver el import a undefined y dejar un hueco silencioso.
    if (handleChunkLoadError(event.payload, null, rest)) {
      event.preventDefault()
    }
  }
  target.addEventListener('vite:preloadError', handler)
  return () => target.removeEventListener('vite:preloadError', handler)
}
